import {dispatch, getState} from '../../../system/store';
import * as actions from '../actions';

export default (payload, next) => {
    let settings = getState("setting");
    if (Array.isArray(settings.setting) && settings.setting.length === 0) {
        dispatch(actions.fetchSetting());
    }
    next(payload);
};